import { GtmhubController } from "@gtmhub/core";
import { IComponentOptions, IOnChangesObjectOf, IPromise, IQService } from "angular";
import { IKpiGroup, KpiService } from "@gtmhub/kpis";
import { IdMap, toIdMap } from "@gtmhub/util";
import { byTextField } from "@gtmhub/util/sorting";

interface IGroupsSelectorBindings {
  ids: string[];
  onUpdate(ids: { ids: string[] }): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface KpiGroupSelectorCtrl extends IGroupsSelectorBindings {}
export class KpiGroupSelectorCtrl extends GtmhubController {
  selectedGroups: IKpiGroup[];
  groups: IdMap<IKpiGroup>;
  showActions: boolean;

  static $inject = ["KpiService", "$q"];

  constructor(private kpiService: KpiService, private $q: IQService) {
    super();
  }

  $onInit(): void {
    this.showActions = false;
    this.$q.resolve(
      this.kpiService.getKpiGroups().then(({ items }) => {
        this.groups = toIdMap(items.sort(byTextField("name")));
        this.processGroups();
      })
    );
  }

  $onChanges(onChangesObj: IOnChangesObjectOf<IGroupsSelectorBindings>): void {
    if (
      onChangesObj.ids &&
      Array.isArray(onChangesObj.ids.currentValue) &&
      Array.isArray(onChangesObj.ids.previousValue) &&
      onChangesObj.ids.currentValue.toString() !== onChangesObj.ids.previousValue.toString()
    ) {
      this.ids = onChangesObj.ids.currentValue;
      this.processGroups();
    }
  }

  emitIds(): void {
    const ids = this.selectedGroups.map((group) => group.id);
    this.onUpdate({ ids });
  }

  processAction(query: string): void {
    const newGroup = {
      id: "new-" + query,
      name: query,
    };

    this.ids.push(newGroup.id);
    this.selectedGroups.push(newGroup);
    this.groups[newGroup.id] = newGroup;
  }

  searchGroups(searchTerm: string): IPromise<IKpiGroup[]> {
    const groupsMap = angular.copy(this.groups);
    this.selectedGroups.forEach((a) => delete groupsMap[a.id]);

    const groups = Object.values(groupsMap);
    const groupsArr: IKpiGroup[] = this.searchInGroups({
      groups: Object.values(groupsMap),
      groupName: searchTerm,
    });

    this.showActions = groupsArr.length === 0 || !groups.some((group) => group.name === searchTerm);

    return this.$q.resolve(groupsArr);
  }

  private searchInGroups = (options: { groups: IKpiGroup[]; groupName?: string }): IKpiGroup[] => {
    return options.groups.filter((group) => (options.groupName ? group.name.toLowerCase().includes(options.groupName.toLowerCase()) : true));
  };

  private processGroups(): void {
    this.selectedGroups = (this.ids || []).map((id) => this.groups[id]);
  }
}

export const KpiGroupSelectorComponent: IComponentOptions = {
  controller: KpiGroupSelectorCtrl,
  templateUrl: require("./kpi-group-selector.jade"),
  bindings: {
    ids: "<",
    onUpdate: "&",
  },
};
